"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const request_1 = require("../common/request");
const constants_1 = require("../common/constants");
const common_functions_1 = require("../common/common-functions");
class CrmService {
    constructor() {
        this._commonNetworkService = new nodejs_library_1.CommonNetworkService();
    }
    isSuperUser() {
        return __awaiter(this, void 0, void 0, function* () {
            let isSuperUser = false;
            // verifico se sono o meno superUser
            const localData5Storage = yield nodejs_library_1.Helpers.SessionHelper.getData(constants_1.Constants.lsMapObject._data5).catch((e) => console.error("Errore nel recupero di dati 5", e));
            if (localData5Storage) {
                const jsonObject = JSON.parse(localData5Storage);
                // tslint:disable-next-line: triple-equals
                if (jsonObject.value0 == "0") {
                    isSuperUser = true;
                }
            }
            return isSuperUser;
        });
    }
    myPostLogin() {
        const request = new request_1.Request("contesto-utente/v1/crm/myPostLogin", {
            body: {
                channel: "TPD_Web",
            },
        });
        return this._commonNetworkService.post(request.completeUrl, request.body);
    }
    getRoadsideAssistance(numberPlate, company, policyNumber, policyBranch, policyAgency, date) {
        const request = new request_1.Request(`contratti/v1/polizze/roadsideAssistance`, {
            queryParams: {
                numberPlate,
                company,
                policyNumber,
                policyBranch,
                policyAgency,
                date,
            },
        });
        return this._commonNetworkService.get(request.completeUrl);
    }
    /**
     * Usage:
     * Se chiamato senza CF-> Servizio di verifica dell'utente prospect. Viene chiamato senza parametri e ritorna un oggetto contenente
     * le informazioni dell'utente:
     * customerInfo.classification == 0 PROSPECT ONLINE,
     * customerInfo.classification == 1 PROSPECT AGENZIA,
     * customerInfo.classification == 2 CLIENTE NORMALE
     *
     * Se chiamato con CF-> Servizio richiamato in fase di registrazione da area pubblica, necessita la generazione di un token per
     * la comunicazione con il server.
     * @param "constants" : richiede le costanti del file Constants.ts;
     * @param "cfCliente";
     * @return Promise<any>;
     */
    // GET /validaDatiUtente
    validaDatiUtente(cfCliente, xToken) {
        return __awaiter(this, void 0, void 0, function* () {
            if (nodejs_library_1.Helpers.EnvironmentHelper.isClientSide() &&
                !nodejs_library_1.Helpers.PageHelper.isHCLAuthoringPage()) {
                // let isSuperUser = false;
                // let data5Storage = null;
                // try {
                //     data5Storage = await Helpers.SessionHelper.getData(
                //         Constants.lsMapObject._data5
                //     );
                // } catch (error) {
                //     console.error("Errore nel recupero del dato da storage:", error);
                // }
                //
                // if (data5Storage) {
                //     const jsonObject = JSON.parse(data5Storage);
                //     if (jsonObject.value0 == "0") {
                //         isSuperUser = true;
                //     }
                // }
                const isSuperUser = yield this.isSuperUser();
                if (!isSuperUser && cfCliente) {
                    const body = common_functions_1.CommonFunctions.encryptBFFRequest(cfCliente);
                    const request = new request_1.Request(`registrazioni/v1/unsecure/utenti/info-cliente`, {
                        body: body,
                    }, undefined, undefined, "url_pub", true); // QUESTA CONFIGURAZIONE SERVE PER CHIAMARE L'API PUBBLICA
                    request.headers = { "Content-Type": "text/plain" };
                    if (xToken) {
                        request.headers["x-token"] = xToken;
                    }
                    return this._commonNetworkService.post(request.completeUrl, request.body, request.headers);
                }
                else {
                    const headers = {
                        infootp: true,
                        infoprospect: true,
                        posticipaPrivacy: false,
                    };
                    const request = new request_1.Request("contesto-utente/v1/me/infoUtente", {
                        headers: headers,
                    }, false, false, "url_priv");
                    // const response = (await this.baseCommunicator.get(request)) as any;
                    const response = yield this._commonNetworkService.get(request.completeUrl, request.headers);
                    return {
                        customerInfo: {
                            name: response.infoUtente.nome,
                            surname: response.infoUtente.cognome,
                            classification: response.infoUtente.classificazione.toString(),
                            partyId: response.infoUtente.partyIdCliente,
                        },
                        operationResult: {
                            message: null,
                            type: null,
                        },
                    };
                }
            }
            else {
                return new Promise((resolve) => {
                    resolve(null);
                });
            }
        });
    }
}
exports.CrmService = CrmService;
